import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {ScenarioGroup} from '../models/scenario-group.model';
import {ScenarioGroupService} from '../services/scenario-group.service';
import {UtilService} from '../services/util.service';
import {catchError, map} from 'rxjs/operators';
import {UiBlockerService} from '@app/services/ui-blocker.service';

@Injectable({providedIn: 'root'})
export class ScenarioGroupResolver implements Resolve<ScenarioGroup[]> {

  constructor(private service: ScenarioGroupService,
              private utilService: UtilService,
              private uiBlockerService: UiBlockerService,
              private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<ScenarioGroup[]> {
    this.uiBlockerService.block();
    const modelRunId = this.utilService.getRouteParameter(route, 'modelRunId');
    const projectId = +this.utilService.getRouteParameter(route, 'projectId');
    return this.service.fetchAll(projectId, modelRunId).pipe(map((groups) => {
      this.uiBlockerService.unblock();
      return groups;
    }), catchError(() => {
      this.uiBlockerService.unblock();
      this.router.navigate(['/404']);
      return of(null);
    }));
  }
}
